import axios from '@/api/axiosInstance';

export default async function getReinforcementActivityData(
  taskActivityId?: number | string
) {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/tasks/taskActivities/${taskActivityId}/reinforcement`,
  });

  return response.data;
}
